export default __webpack_public_path__ + "static/media/974.6c5ae737.png";